const legals = {
    name: "legals",
    label: "Legals",
    label_singular: "Legal Page",
    description: "Legal related pages",
    show_preview_links: true,
    folder: "site/content/legal/",
    filter: { field: "hidden", value: false },
    create: true,
    i18n: true,
    editor: {
        preview: true
    },
    fields: [
        {
            label: "Title",
            name: "title",
            widget: "string",
            i18n: true,
        },
        { label: "Weight", name: "weight", widget: "number", default: 0, i18n: true,},
        { label: "Summary", name: "summary", widget: "text", required: false, i18n: true},
        {label: "Type", name: "type", widget: "hidden", default: "legal", i18n: true},
        {
            label: "Body",
            name: "body",
            widget: "markdown",
            i18n: true
        }
    ],
}

export default legals;
